module.exports = {"private":true,"main":"./MultiCheckbox.js"}


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/fields/MultiCheckbox/package.json
// module id = 834
// module chunks = 0 1